import { TextStyle } from 'react-native';

// Font configuration
// ================================================
// Set USE_CUSTOM_FONT to false to use the default system font
// Set to true to use the Minecraftia pixel font
// ================================================
export const USE_CUSTOM_FONT = false;

// Custom font family name (must match the font file name without extension)
export const CUSTOM_FONT_FAMILY = 'Minecraftia';

// Second font for logo (must match the font file name without extension)
export const LOGO_FONT_FAMILY = 'secondFont';

// Third font for header logo (must match the font file name without extension)
export const HEADER_LOGO_FONT_FAMILY = 'kongtext';

// Get the font family to use based on configuration
export const getFontFamily = (): string | undefined => {
  return USE_CUSTOM_FONT ? CUSTOM_FONT_FAMILY : undefined;
};

// Get font style object to apply to Text components
// Usage: <Text style={[styles.myText, fontStyle]}>Hello</Text>
export const fontStyle: TextStyle = USE_CUSTOM_FONT
  ? { fontFamily: CUSTOM_FONT_FAMILY }
  : {};

// Helper to create text styles with the custom font
// Usage in StyleSheet: textStyle: createFontStyle({ fontSize: 16, color: 'red' })
export const createFontStyle = (style: TextStyle = {}): TextStyle => {
  return USE_CUSTOM_FONT
    ? { ...style, fontFamily: CUSTOM_FONT_FAMILY }
    : style;
};
